<template>
	<div>
		<case-form :schema="schemaCovid" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">你曾今有过:</div>
		<case-form :schema="schema" />

		<case-form :schema="smokingHabits" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">如选择"是"，请完成以下问题：</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">附加资料</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="smokingHabitsList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="drugHabits" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">如选择"是"，请完成以下问题：</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">附加资料</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="drugHabitsList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="alcoholConsumption" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			请参考问题编号，
			并提供详细信息，包括发生日期，病症，及医生，诊所，医生和医院的名称和地址。
		</div>
		<j-accordion
			v-for="i in 22"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">附加资料</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form
					:schema="schemaPersonalHealthExtraDetails(i)"
					:isBoxed="false"
				/>
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		schema() {
			return [
				{
					label: `B1. 高血压，高胆固醇，心绞痛，胸痛，心脏病发作，冠状动脉疾病，心脏杂音，心律不齐，短暂性脑缺血发作（TIA）， 中风或脑血管意外（CVA），血凝块，周围血管疾病（ 血液循环不良）， 动脉瘤或任何其他心脏或血管疾病或失调？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ1CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ1CN`
						},
						createOptions: {
							type: `personalHealthQ1CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B2. 贫血，血友病或任何其他血液或出血性疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ2CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ2CN`
						},
						createOptions: {
							type: `personalHealthQ2CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B3. 哮喘，慢性阻塞性肺疾病（COPD），肺气肿，慢性或复发性支气管炎，睡眠呼吸暂停，结节病，囊性纤维化，结核 病，持续咳嗽，声音嘶哑，呼吸急促或呼吸困难，或任何其他呼吸系统疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ3CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ3CN`
						},
						createOptions: {
							type: `personalHealthQ3CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B4. 慢性焦虑症，抑郁症，勃朗峰症，慢性疲劳综合征，注意缺陷多动障碍（ADD）或注意缺陷多动障碍（ADHD），进食 障碍，精神分裂症，自杀未遂，任何其他心理，情感或神经疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ4CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ4CN`
						},
						createOptions: {
							type: `personalHealthQ4CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B5. 肝炎（包括肝炎携带者状态），肝硬化，黄疸，克罗恩病，溃疡性结肠炎，肠易激综合症，憩室炎，持续腹泻，胃， 胰腺或肝脏直肠或肠道出血，溃疡（消化性或胃性），胰腺炎或任何其他肠道、胃，胰腺或肝脏疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ5CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ5CN`
						},
						createOptions: {
							type: `personalHealthQ5CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B6. 糖尿病，妊娠糖尿病，血糖异常，甲状腺肿，甲状腺功能亢进，甲状腺功能减退，淋巴或腺体疾病或疾病，或任何 其他甲状腺，垂体或内分泌疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ6CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ6CN`
						},
						createOptions: {
							type: `personalHealthQ6CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B7. 狼疮，硬皮病，关节炎，纤维肌痛，肌肉营养不良，瘫痪，或皮肤，结缔组织，肌肉，关节，四肢，背部或骨骼的 任何其他疾病或失调？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ7CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ7CN`
						},
						createOptions: {
							type: `personalHealthQ7CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B8. 癌症，白血病，淋巴瘤，黑素瘤，增生性痣（非典型痣），基底细胞癌，肿瘤，囊肿，息肉，任何其他生长或恶性肿 瘤？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ8CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ8CN`
						},
						createOptions: {
							type: `personalHealthQ8CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B9.  前列腺特异性抗原（PSA）异常，前列腺炎或任何其他前列腺疾病或疾患，乳房肿块或囊肿，乳房 X 线照片或乳头涂片 异常，子宫切除术，卵巢或子宫疾病或疾患，性传播疾病，生殖器官疾病或病症，肾结石，肾炎，尿路感染，尿液中 的糖、血液或蛋白质，或任何其他肾脏或膀胱疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ9CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ9CN`
						},
						createOptions: {
							type: `personalHealthQ9CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B10. 自闭症，脑瘫，唐氏综合症，发育迟缓，癫痫或癫痫发作，多发性硬化症（MS），失去平衡，意识，感觉或言语，昏 迷， 脑震荡，严重头痛，头晕，昏厥，帕金森氏病 ，震颤，阿尔茨海默氏病，痴呆或认知障碍，肌萎缩性侧索硬化 症（ALS），或任何其他大脑或神经系统疾病或失调疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ10CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ10CN`
						},
						createOptions: {
							type: `personalHealthQ10CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B11. 眼睛（不包括通过眼镜或隐形眼镜矫正的视力障碍），耳朵，鼻子，喉咙或嘴巴的任何疾病？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ11CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ11CN`
						},
						createOptions: {
							type: `personalHealthQ11CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `C. 您是否曾经接受过测试或是否有人建议您接受过艾滋病 HIV（AIDS）病毒测试？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTestedForHIVCN`,
					props: {
						suggest: {
							typeIncludes: `hasTestedForHIVCN`
						},
						createOptions: {
							type: `hasTestedForHIVCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `D. 您是否曾接受过艾滋病治疗，或有过任何艾滋病迹象，HIV 感染或任何其他免疫系统疾病或病症？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasHIVCN`,
					props: {
						suggest: {
							typeIncludes: `hasHIVCN`
						},
						createOptions: {
							type: `hasHIVCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `E. 您曾经接受过输血吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBloodTransfusionCN`,
					props: {
						suggest: {
							typeIncludes: `hasBloodTransfusionCN`
						},
						createOptions: {
							type: `hasBloodTransfusionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `F. 除了已经披露的情况外，在过去五年中，您是否进行过任何医学或诊断检查, 例如 X 射线，ECG，扫描，MRI 核磁共振， B 超，活检或血液检查？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMedicalOrDiagnosticTestCN`,
					props: {
						suggest: {
							typeIncludes: `hasMedicalOrDiagnosticTestCN`
						},
						createOptions: {
							type: `hasMedicalOrDiagnosticTestCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `G. 最近十年您是否住院过或进行过任何手术？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasSurgeryCN`,
					props: {
						suggest: {
							typeIncludes: `hasSurgeryCN`
						},
						createOptions: {
							type: `hasSurgeryCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `H. 您有尚未咨询医生或接受过治疗的任何症状吗？ `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasUnconsultedSymptomsCN`,
					props: {
						suggest: {
							typeIncludes: `hasUnconsultedSymptomsCN`
						},
						createOptions: {
							type: `hasUnconsultedSymptomsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `I. 除了已经披露的情况外，是否有医生建议您完成但尚未完成的任何检查或转诊, 或者您目前正在等待检查结果？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isWaitingForTestResultCN`,
					props: {
						suggest: {
							typeIncludes: `isWaitingForTestResultCN`
						},
						createOptions: {
							type: `isWaitingForTestResultCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `J. 您有畸形或截肢吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeformityOrAmputationCN`,
					props: {
						suggest: {
							typeIncludes: `hasDeformityOrAmputationCN`
						},
						createOptions: {
							type: `hasDeformityOrAmputationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `K. 您是否正在服用任何处方药或非处方药？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isUnderMedicationCN`,
					props: {
						suggest: {
							typeIncludes: `isUnderMedicationCN`
						},
						createOptions: {
							type: `isUnderMedicationCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCovid() {
			return [
				{
					label: `您是否有过对COVID-19测试阳性？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTestedPostiveForCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasTestedPostiveForCovid19CN`
						},
						createOptions: {
							type: `hasTestedPostiveForCovid19CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去30天内，您是否因COVID-19而被建议自我隔离或留在家中（不包括必须留在家里的强制性政府命令）？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenAdvisedToIsolateDueToCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenAdvisedToIsolateDueToCovid19CN`
						},
						createOptions: {
							type: `hasBeenAdvisedToIsolateDueToCovid19CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去的30天内，您有任何与covid19相关的症状吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasCovid19SymptomsInLast30DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasCovid19SymptomsInLast30DaysCN`
						},
						createOptions: {
							type: `hasCovid19SymptomsInLast30DaysCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去30天内，您是否与怀疑或确认患有COVID-19的个人进行了接触？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasContactWithCovid19PatientInLast30DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasContactWithCovid19PatientInLast30DaysCN`
						},
						createOptions: {
							type: `hasContactWithCovid19PatientInLast30DaysCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `如果以上任何一项是"是"，您是否已完全康复并恢复了正常活动？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRecoveredFromCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasRecoveredFromCovid19CN`
						},
						createOptions: {
							type: `hasRecoveredFromCovid19CN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		smokingHabits() {
			return [
				{
					label: `您曾否吸食任何形式的烟草或尼古丁产品（包括香烟、雪茄、小雪茄、烟斗、嚼烟、尼古丁贴片 或尼古丁香口糖）? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProductCN`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProductCN`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProductCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		drugHabits() {
			return [
				{
					label: `在过去的十年中，您是否使用过可卡因，LSD 或其他精神药物，海洛因或其他麻醉品？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasUsedPsychoactiveDrugsInPast10YearsCN`,
					props: {
						suggest: {
							typeIncludes: `hasUsedPsychoactiveDrugsInPast10YearsCN`
						},
						createOptions: {
							type: `hasUsedPsychoactiveDrugsInPast10YearsCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		alcoholConsumption() {
			return [
				{
					label: `您现在饮酒吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isCurrentlyDrinkingAlcoholCN`,
					props: {
						suggest: {
							typeIncludes: `isCurrentlyDrinkingAlcoholCN`
						},
						createOptions: {
							type: `isCurrentlyDrinkingAlcoholCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>如“是”，以下哪一项能最准确描述您的平均饮酒频率？ </div>`
					},
					bindTo: ""
				},
				{
					label: `每天`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholDailyCN`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholDailyCN`
						},
						createOptions: {
							type: `isDrinkingAlcoholDailyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `每周`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholWeeklyCN`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholWeeklyCN`
						},
						createOptions: {
							type: `isDrinkingAlcoholWeeklyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `每月`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholMonthlyCN`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholMonthlyCN`
						},
						createOptions: {
							type: `isDrinkingAlcoholMonthlyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `每月少于一次`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholOncePerMonthCN`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholOncePerMonthCN`
						},
						createOptions: {
							type: `isDrinkingAlcoholOncePerMonthCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `当您饮酒时，通常喝多少？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alcoholConsumptionPerDayCN`,
					props: {
						suggest: {
							typeIncludes: `alcoholConsumptionPerDayCN`
						},
						createOptions: {
							type: `alcoholConsumptionPerDayCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您是否曾因使用药物或酒精而接受过治疗或被建议减少使用或减少使用频率，寻求治疗，咨询或医疗建议？如“是”，请在 Q 项中注明咨询或治疗的类型，以及开始和结束的日期（包括参与的任何组织/支持团体）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alcoholConsumptionCounselingCN`,
					props: {
						suggest: {
							typeIncludes: `alcoholConsumptionCounselingCN`
						},
						createOptions: {
							type: `alcoholConsumptionCounselingCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPersonalHealthExtraDetails(i) {
			return [
				{
					label: `问题编号`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQuestionNumber${i}CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQuestionNumber${i}CN`
						},
						createOptions: {
							type: `personalHealthQuestionNumber${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDate${i}CN`
						},
						createOptions: {
							type: `personalHealthDate${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `详细信息`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDetails${i}CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDetails${i}CN`
						},
						createOptions: {
							type: `personalHealthDetails${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `医生、诊所、医疗保健顾问或医院的名称和地址`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDoctorNameAndDetails${i}CN`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDoctorNameAndDetails${i}CN`
						},
						createOptions: {
							type: `personalHealthDoctorNameAndDetails${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		smokingHabitsList(i) {
			return [
				{
					label: `产品类型`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoProduct${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoProduct${i}CN`
						},
						createOptions: {
							type: `tobaccoProduct${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `用量和使用频率`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoFrequency${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoFrequency${i}CN`
						},
						createOptions: {
							type: `tobaccoFrequency${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `最近一次使用日期(日/月/年)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoDateLastUsed${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoDateLastUsed${i}CN`
						},
						createOptions: {
							type: `tobaccoDateLastUsed${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		},

		drugHabitsList(i) {
			return [
				{
					label: `产品类型`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugProduct${i}CN`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugProduct${i}CN`
						},
						createOptions: {
							type: `psychoactiveDrugProduct${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `用量和使用频率`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugAmount${i}CN`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugAmount${i}CN`
						},
						createOptions: {
							type: `psychoactiveDrugAmount${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `最近一次使用日期(日/月/年)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugLastUsed${i}CN`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugLastUsed${i}CN`
						},
						createOptions: {
							type: `psychoactiveDrugLastUsed${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
